import * as React from 'react';
import { Arrays } from '../../utils/arrays';
/** For internal component use - combine validation errors from a prop with those from a bind */

export function useMyValidationErrorMessages(bind, validationErrorMessages) {
  return React.useMemo(function () {
    var _a;

    return Arrays.flatten(validationErrorMessages || [], ((_a = bind === null || bind === void 0 ? void 0 : bind.myValidationErrors) === null || _a === void 0 ? void 0 : _a.map(function (error) {
      return error.message;
    })) || []);
  }, [validationErrorMessages, bind === null || bind === void 0 ? void 0 : bind.myValidationErrors]);
}